import { createApi } from '@/api'
export default {
	getvoluntList: config => createApi( `/serviceStaff/pageSearch`, 'post', config ),
	voluntDetail: config => createApi(`/serviceStaff/get`, 'post', config),
	addvolunt: config => createApi(`/serviceStaff/add`, 'post', config),
	deletevolunt: config => createApi(`/serviceStaff/delete`, 'delete', config),
	updatevolunt: config => createApi(`/serviceStaff/update`, 'post', config)
}



// WEBPACK FOOTER //
// ./src/views/serviceStaff/api/index.js